export const Colors = {
  primary: "#ffb92a",
  secondary: "#1c1917",
  container: "#1e293b",
  text: "#ffffff",
  special: "#a0a0a0",
}